export const config = {
  apiUrl: process.env.VUE_APP_API_URI || 'http://localhost:3000',
  salt: "$2a$10$2oIYOQCW2UR0omcSdlIOku",
  auth0Domain: process.env.VUE_APP_AUTH0_DOMAIN || 'dev-nx353opa4s4f0tzl.eu.auth0.com',
  auth0ClientId: process.env.VUE_APP_AUTH0_CLIENT_ID || 'vBNBj0gZCaAZE67jWoYdUfxYTHkPDXnS',
  auth0Audience: process.env.VUE_APP_AUTH0_AUDIENCE || 'Dev-Env-API'
}
